import { useState } from "react";
import { LoadingIndicator } from "../../ui-components/LoadingIndicator/LoadingIndicator";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { Popup } from "../Popup/Popup";
import { SelectInputData, SelectInputField } from "../SelectInputField/SelectInputField";

type Props = {
  id: string;
  title: string;
  placeholder: string | undefined;
  options: { key: string; title: string }[];
  didSelect: (key: string) => void;
  defaultSelected?: string;
  isLoading?: boolean;
};
export const SelectPopup = ({ didSelect, id, options, placeholder, title, defaultSelected, isLoading }: Props) => {
  const [selected, setSelected] = useState<string | undefined>(defaultSelected);
  return (
    <ModalPopup
      id={id}
      title={title}
      disableAction={selected === undefined}
      onActionClicked={() => {
        if (selected) {
          Popup.remove(id);
          didSelect(selected);
        }
      }}
    >
      {isLoading ? (
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <LoadingIndicator />
        </div>
      ) : (
        <div>
          <SelectInputField
            placeholder={placeholder}
            options={options.map((option) => new SelectInputData(option.key, option.title))}
            onChange={(selectedOption) => selectedOption && setSelected(selectedOption.value)}
            value={selected}
            width="100%"
            menuPortalTarget="popup"
          />
        </div>
      )}
    </ModalPopup>
  );
};

